<template>
  <div class="layout_landing">
    <router-view></router-view>
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
  </div>
</template>
<script>
import PublicPageCss from "@/assets/sass/index_public.scss";
import { ArrowUpIcon } from "vue-feather-icons";
export default {
  components: { ArrowUpIcon },
  data() {
    return {};
  },
  methods: {}
};
</script>
